import React from 'react'
import { ObjectType } from '@/core/models/document.model'
import { Box, CircularProgress, Typography, Alert } from '@mui/material'
import { PatientDocumentList } from '@/features/patient/patient-documents'
import { useFindFilesByObjectQuery } from '@/core/services/file'

interface FileViewerProps {
  objectId: string
  objectType: ObjectType
}

export const FileViewer: React.FC<FileViewerProps> = ({ objectId, objectType }) => {
  const { data: files, error, isLoading } = useFindFilesByObjectQuery({ objectId, objectType })

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
        <CircularProgress size={20} sx={{ mr: 2 }} />
        <Typography variant="body2">Loading files...</Typography>
      </Box>
    )
  }

  if (error) {
    return <Alert severity="error">Could not load files.</Alert>
  }

  if (!files || files.length === 0) {
    return <Alert severity="info">No files found for this item.</Alert>
  }

  // The Documents component expects a certain shape, so we map the fetched files to it.
  const documentsForComponent = files.map((file) => ({
    filename: file.filename,
    key: file.key,
    url: file.url,
    // Add other properties if the Documents component needs them
  }))

  return (
    <Box sx={{ mt: 2 }}>
      <PatientDocumentList
        documents={documentsForComponent}
        totalCount={documentsForComponent.length}
        onDelete={undefined}
        onUpload={undefined}
        onSaveFileName={undefined}
      />
    </Box>
  )
}

export default FileViewer
